
import React, { createContext, useState, useContext } from "react";

const EnergiaRefrigeracaoContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaRefrigeracao_id, setEnergiaRefrigeracao_id] = useState();

  return (
    <EnergiaRefrigeracaoContext.Provider value={{ energiaRefrigeracao_id, setEnergiaRefrigeracao_id }} >
      {children}
    </EnergiaRefrigeracaoContext.Provider>
  );
}

export function useEnergiaRefrigeracaoContext() {
  const context = useContext(EnergiaRefrigeracaoContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaRefrigeracao_id, setEnergiaRefrigeracao_id } = context;
  return { energiaRefrigeracao_id, setEnergiaRefrigeracao_id };
}

